import { render, staticRenderFns } from "./DownloadCertificate.vue?vue&type=template&id=dedf1962&scoped=true&"
import script from "./DownloadCertificate.vue?vue&type=script&lang=js&"
export * from "./DownloadCertificate.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCertificate.vue?vue&type=style&index=0&id=dedf1962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedf1962",
  null
  
)

export default component.exports